module.exports = __webpack_public_path__ + "static/media/dots-about-us.609fe4c3.svg";